import { Grid } from '@material-ui/core';
import { Icon, Upload, DatePicker, Spin, Result, Button, Divider} from 'antd';
import TextEvents from 'app/components/TextEvents';
import { fetchAttachment, attachmentClear } from "app/actions/AttachmentActions";
import { getAttachment  } from "app/reducers";
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';

export default function AttachFileContainer(props) {

    const dispatch = useDispatch();
    const [validDoc, setValidDoc] = useState(true)
    const reader = new FileReader();
    const { Dragger } = Upload;
    const courseAttachment = useSelector(getAttachment);
    const [state, setState] = useState({
        fileList: [],
        finishedOrError: false,
        idCourse: props.id,
        typeDoc: true,
        loadStatus: 'initial',
        iconName: {
            'initial': 'cloud-upload',
            'loading': 'loading',
            'success': 'smile',
            'error': 'frown',
        },
        fileName: '',
        pdf: '',
        url:'',
        numPages: null,
        pageNumber: 1

    })
    const params = props.children({ state, courseAttachment });
    const fetchCourseAttachmentAction = () => dispatch(fetchAttachment(state.idCourse));
    useEffect(() => {
        if (props.localAttachment===undefined && isEmpty(courseAttachment)) {
            fetchCourseAttachmentAction();
        }else if(props.localAttachment!==undefined){
            state.url=props.localAttachment
        }
    }, []);

    const {
        siteId
    } = useSelector(state => state.Auth)

    const actions = {
        multiple: false,
        onRemove: file => {
            const index = state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            setState({ ...state, fileList: newFileList })
        },
        beforeUpload: file => {
            setState({...state, fileList: []})
            state.fileList = [file];
            state.isLoading = true;
            createFile(state.fileList);
            return false
        },
        state,
    };

    const mediaDuration = (file) => new Promise((resolve, reject) => {
        reader.readAsDataURL(file);
        const reading = reader.onload = function () {
            const fileData = reader.result;
            state.fileName = file.name;
            state.fileExtension = '.pdf';
            state.fileInformation = fileData.toString().replace('data:application/pdf;base64,', '');//dataFile[1]
            resolve(fileData);
        }
    });

    const createFile = (file) => new Promise(async (resolve, reject) => {
        setState({ ...state, loadStatus: 'loading' });
        await mediaDuration(state.fileList[0]).then(
            result => {
                const myImage ='dec';
                resolve(myImage);
                migrateData(state);
            });

    });

    const migrateData = async (dataFile) => {
        var file = {
            idCourse: dataFile.idCourse,
            fileName: dataFile.fileName,
            fileExtension: dataFile.fileExtension,
            fileInformation: dataFile.fileInformation
        }
        props.setMigrate(file);
        setState({ ...state, loadStatus: 'success' });
        getfile(file.fileInformation);
        // dispatch(fetchAttachment(state.idCourse))
        // dispatch(attachmentClear());
        
    }


    const draggerText = {
        Text: function () {
            return (
                <div>
                    <p className="ant-upload-drag-icon">
                        <Icon type={state.iconName[state.loadStatus]} />
                    </p>
                    <p className="ant-upload-text">
                        {state.loadStatus === 'initial' ? 'Selecciona o arrastra un archivo' : 'Subiendo archivo...'}
                    </p>
                    <p className="ant-upload-hint">
                        {state.loadStatus === 'initial' ? 'Únicamente formatos .pdf'  : ''}
                    </p>
                </div>
            )
        },
        finishedText: function () {
            return (
                <div>
                    <p className="ant-upload-drag-icon">
                        <Icon type={state.iconName[state.loadStatus]} />
                    </p>
                    <p className="ant-upload-text">
                        {state.loadStatus === 'success' ? 'Carga de Archivo exitosa!' : 'Ops! ocurrio un error, intente nuevamente.'}
                    </p>
                </div>
            )
        }
    }

    const converBase64toBlob = (content, contentType) =>{
        contentType = contentType || '';
        var sliceSize = 512;
        var byteCharacters = window.atob(content); //method which converts base64 to binary
        var byteArrays = [
        ];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {
            type: contentType
        }); //statement which creates the blob
        return blob;
    }

    const downloadPDF = () => {
        let link = document.createElement('a');
        link.href = state.url;
        link.download = "Adjunto";
        document.body.append(link);
        link.click();
        link.remove();
    };

    const getfile = (base64) => {
        state.pdf = base64;
        let file = converBase64toBlob(base64, 'application/pdf');
        const blob = new Blob([file], { type: 'application/pdf' });
        state.url = URL.createObjectURL(blob);
        props.setAttachment(state.url);
        setState({...state, url: URL.createObjectURL(blob)})
        props.setLoadDocument(true);
    }

    if (Object.keys(courseAttachment).length !== 0) {
        if (state.pdf === '' && props.localAttachment===undefined) {
            getfile(courseAttachment.Data[0].attachmentFile);
        }
    }		

 
    return params && (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Dragger {...actions} disabled={state.loadStatus !== 'initial' || siteId !== 'HUB'} accept={'.pdf'} fileList={state.fileList}>
                        {state.loadStatus === 'initial' || state.loadStatus === 'loading' ? <draggerText.Text /> : <draggerText.finishedText />}
                    </Dragger>
                    <div>
                        <p className="ant-upload-text">
                            {!validDoc ? 'La extensión de archivo no es válida' : null}
                        </p>
                    </div>
                </Grid>
                <Divider />
                <Grid item xs={12} >
                    {
                        (state.pdf !== '') ?
                            <a href={state.url} target="_blank" >Abrir documento </a>
                            : ''
                    }
                    {
                        (state.pdf !== '') ?
                            <Button  type='primary' onClick={downloadPDF}>Descargar</Button>
                            : ''
                    }
                </Grid>
               
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        {props.localAttachment===undefined && props.loadDocument && state.url === "" ?
                            <Spin tip="Cargando Documento..." />
                            : (!props.loadDocument) ? <Result status="warning" title="Sin Documento" /> :''

                        }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        ( props.localAttachment!==undefined || state.pdf !== '') ?
                            <object name="Inline Frame Example" data={props.localAttachment!==undefined ? props.localAttachment : state.url} type="application/pdf" width="100%" height="400" frameBorder="0" allowFullScreen={true}>

                            </object>
                            : ''
                        }
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text="Fecha de Elaboración de Documento de Soporte"
                        color="darker"
                        size='label'
                        weight="medium"
                    />

                    <DatePicker
                        disabled={!props.loadDocument || siteId !== 'HUB'}
                        format={'DD/MM/YYYY'}
                        defaultValue={props.courseSupportFileDate === null ? null: moment(props.courseSupportFileDate)}
                        onChange={(date, dateString) => {
                            props.setCourseSupportFileDate(dateString !== "" ? dateString.split('/').reverse().join('/') : null);
                        }}
                  />
                </Grid>
            </Grid>
        </div>
    );
}



